import React, { useEffect, useState } from 'react'
import { list, getUserByCID, setActiveInActive, deleteCompanyByID } from '../api/company';
import Loader from '../components/Loader';
import { updateUserData } from '../api/user';
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function Company() {
    const { user, setUser } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [companyStatus, setCompanyStatus] = useState("");
    const [companyName, setCompanyName] = useState("0");
    const [userList, setUserList] = useState([]);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [pendingConfirm, setPendingConfirm] = useState(null);
    const [option, setOption] = useState([{
        "id": "",
        "companyName": "Please select company"
    }]);
    const isTdr = user.db?.toLowerCase() === 'tdr';
    const getCompanyList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, companyName: "Please select company" },
            ...data.data.data.map(obj => ({
                ...obj,
                companyName: `${obj.companyName} (${obj?.clientID || obj?.email || ""})`,
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.companyName.localeCompare(b.companyName, undefined, { sensitivity: "base" })
            )
            ]);

        }

    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        setCompanyName("0");
        setCompanyStatus("");
        setUserList([]);
        getCompanyList();
    }, [user.db]);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getUserList = async (companyName) => {
        if (companyName !== "0") {
            setLoading(true);
            let userData = await getUserByCID(companyName);
            setLoading(false);
            if (userData.status > 199 && userData.status <= 399) {
                const updatedUserList = userData.data.data.map(obj => {
                    console.log("Map Status", obj.status);
                    return toggleStatus(obj); // Update the status for the user
                    // Return the updated user object
                });
                setUserList(updatedUserList);
            } else {
                setUserList([]);
            }
        } else {
            setUserList([]);
        }
    }
    const handleChange = async (e) => {
        const { value, } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const cStatus = selectedOption.getAttribute('cStatus');
        setCompanyStatus(cStatus);
        setCompanyName(value);
        getUserList(value);

    }


    const handleUserUpdate = async (obj, fieldName) => {
        setLoading(true);
        let passObj = {
            _id: obj._id
        }
        if (fieldName === "password") {
            passObj["password"] = "Welcome1"
        } else if (fieldName === "status") {
            passObj["status"] = obj.status?.trim().toLowerCase() === "inactive" ? "Active" : "InActive"
            // passObj["status"] = obj.status
        } else if (fieldName === "loginattempt") {
            passObj["loginattempt"] = 0;
        }
        const updateRes = await updateUserData(passObj);
        setLoading(false);
        if (updateRes.status > 199 && updateRes.status <= 399) {
            let text = "User update successfully";
            if (fieldName === "loginattempt") {
                text = "Login attempts have been reset successfully."
            } else if (fieldName === "password") {
                text = "Password has been changed successfully."
            }

            setApiError(text);
            setErrorStatus("success")
            await getUserList(companyName);

        } else {
            setApiError(updateRes?.data?.message || "There is some technical issue,please try again after sometime")
            setErrorStatus("danger")

        }
    };
    const handleEditUser = async (obj) => {
        navigate(`/registration/${obj._id}/edit-user`)
    };
    const addUser = async () => {
        const result = option.find(c => c._id === companyName);
        navigate(`/registration/${result.clientID}`)
    };

    const deleteCompany = async () => {
        const result = option.find(c => c._id === companyName);
        console.log("Delete Company", result);

        setPendingConfirm({ type: 'delete-company' });
        setShowPopup(true);
        let text = 'Are you sure you want to delete the company? This action cannot be undone.'
        setPopUpMessage({
            "title": "Success",
            "text": text
        })
    }

    const openCreateProUser = (obj) => {
        const declarant = obj?.Role_FreightForwarder || {};
        if (user.db?.toLowerCase() === 'tdr') {
            setUser({ db: 'pro' });
        }
        navigate('/registration', {
            state: {
                copiedUser: {
                    DecEORINumber: declarant.DecEORINumber || '',
                    DecName: declarant.DecName || '',
                    DecAddress: declarant.DecAddress || '',
                    DecCity: declarant.DecCity || '',
                    DecPostalCode: declarant.DecPostalCode || '',
                    DecCountry: declarant.DecCountry || 'GB',
                    DecEmail: declarant.DecEmail || obj.email || '',
                    swprID: obj.swprID || '',
                    FullName: obj.name || '',
                    email: obj.email || '',
                    tdremail: obj.email || '',
                    Address: obj.Address || '',
                    phoneno: obj.phoneno || '',
                    uType: obj.uType || '',
                    password: 'Welcome1',
                    nextSystemUser: obj.nextSystemUser || '',
                    clientID: obj.clientID || '',
                    scope: obj.scope || '',
                    recordlistdaterange: obj.recordlistdaterange || '',
                }
            }
        });
    }

    const updateCompanyInfo = async () => {

    }
    const handlerActiveInactive = async () => {

        setLoading(true);
        const data = await setActiveInActive(companyName);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setApiError(data.data.message)
            setErrorStatus('success')
            setCompanyStatus(data.data.data.status)
            setOption(prevOptions =>
                prevOptions.map(option =>
                    option.id === companyName ? { ...option, status: data.data.data.status } : option
                )
            );
        } else {
            setApiError(data.data.message)
            setErrorStatus('danger')
        }
    }

    function toggleStatus(obj) {
        // Ensure a status field exists; do not flip values coming from the API.
        if (!('status' in obj) || obj.status === '' || obj.status === undefined) {
            obj.status = 'Inactive';
        }
        return obj;
    }
    const closePopup = () => {
        setShowPopup(false);
        setPendingConfirm(null);
        setPopUpMessage({
            "title": "",
            "text": ""
        });
    }

    const onConfirmAction = async () => {
        setShowPopup(false);
        setPendingConfirm(null);
        // Here you can add the logic to delete the company after confirmation
        console.log("Company deletion confirmed", companyName);
        setLoading(true);

        const data = await deleteCompanyByID(companyName);
        setLoading(false);
        console.log("Delete Company Response", data);
        if (data.status > 199 && data.status <= 399) {
            setApiError(data.data.message)
            setErrorStatus('success')
            setUserList([]);
            getCompanyList();
        } else {
            setApiError(data.data.message)
            setErrorStatus('danger')
        }
    }

    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={closePopup}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}
                <div className="form-group">
                    <label htmlFor="exampleSelectGender">Company</label>
                    <select className="form-select" id="exampleSelectGender" name="companyName" value={companyName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                    {obj.companyName}
                                </option>
                            ))}

                    </select>
                </div>
                <div>
                    {(companyName !== "0") &&
                        <nav aria-label="breadcrumb">
                            <button type="submit" className="btn btn-danger me-2" onClick={() => deleteCompany()}>Delete Company</button>
                            <button type="submit" className="btn btn-success me-2" onClick={() => addUser()}>Add User</button>
                            <button className="btn btn-primary me-2" onClick={() => updateCompanyInfo()}>Update Company Info</button>
                            <button className={`btn btn-${companyStatus.trim().toLowerCase() === "active" ? "success" : "danger"} me-2`} onClick={() => handlerActiveInactive()} >Company is {companyStatus}</button>

                        </nav>
                    }
                </div>
                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User List</h4>



                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Name </th>
                                            <th> Email </th>
                                            <th> Phone </th>
                                            <th> Type </th>
                                            <th> Client ID </th>
                                            <th> Login Atte. </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {userList.map((obj, index) => (
                                            <tr key={obj._id} status={obj.status}>
                                                <td> {index + 1} </td>
                                                <td> {obj.name} </td>
                                                <td> {obj.email} </td>
                                                <td> {obj?.phoneno || ""} </td>
                                                <td> {obj.uType} </td>
                                                <td> {obj.clientID} </td>
                                                <td>
                                                    {obj.loginattempt}
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleUserUpdate(obj, "loginattempt")} className="btn btn-primary me-2" >Reset</button>
                                                </td>
                                                <td>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleEditUser(obj)} className="btn btn-primary me-2" >Edit</button>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleUserUpdate(obj, "password")} className="btn btn-danger me-2" >Reset Password</button>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleUserUpdate(obj, "status")} className={`btn btn-${obj.status.trim().toLowerCase() === "active" ? "success" : "danger"} me-2`} >{obj.status}</button>
                                                    {isTdr && obj.userCreatedInProduction !== true && (
                                                        <button style={{ marginLeft: "10px" }} type="button" onClick={() => openCreateProUser(obj)} className="btn btn-warning me-2">Create Pro User</button>
                                                    )}


                                                </td>
                                            </tr>
                                        ))}



                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
